import styled from 'styled-components';

export const HorizontalLine = styled.div`
  width: 100%;
  border-bottom: 1px solid lightgray;
  margin: 20px 0;
  padding: 0px 20px;
`;
